exports = module.exports = require("../../../../vue-ssr-factory/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main[data-v-338dcf6c] {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.tc-panel[data-v-338dcf6c] {\n  margin-top: 1em;\n}\n.tc-15-table-panel .tc-15-dropdown[data-v-338dcf6c] {\n  margin-right: inherit;\n}\n.dosage-icon[data-v-338dcf6c] {\n  font-size: 0;\n}\n", ""]);

